import { SxProps, Theme } from '@mui/material'
import { useCallback, useState } from 'react'

import OFUSimulateContactInput from '~/features/campaigns/components/ofuSimulateContactInput'
import OFUSimulateSteps from '~/features/campaigns/components/ofuSimulateSteps'
import {
  TCampaignFormFields,
  TCampaignGetContact,
} from '~/features/campaigns/models'

export default function OFUSimulate({
  isDisabled,
  campaign,
  allowedAgentIds = undefined,
  variant = 'button',
  initialContact = undefined,
  buttonSx = {},
  onRegisterOpenHandler = undefined,
}: {
  isDisabled: boolean
  campaign: TCampaignFormFields
  allowedAgentIds?: string[]
  variant?: 'button' | 'icon' | 'newUi' | 'hidden'
  initialContact?: TCampaignGetContact
  buttonSx?: SxProps<Theme>
  onRegisterOpenHandler?: (openHandler: () => void) => void
}) {
  const [simulationData, setSimulationData] = useState<{
    contact: TCampaignGetContact
    agentId: string
  } | null>(null)

  const handleCancel = useCallback(() => {
    setSimulationData(null)
  }, [])

  const handleStartSimulation = useCallback(
    ({
      contactData,
      agentId,
    }: {
      contactData: Partial<TCampaignGetContact>
      agentId: string
    }) => {
      setSimulationData({
        contact: contactData as TCampaignGetContact,
        agentId,
      })
    },
    [],
  )

  return (
    <>
      <OFUSimulateContactInput
        isDisabled={isDisabled}
        campaign={campaign as Record<string, unknown>}
        handleStartSimulation={handleStartSimulation}
        allowedAgentIds={allowedAgentIds}
        variant={variant}
        initialContact={initialContact}
        buttonSx={buttonSx}
        onRegisterOpenHandler={onRegisterOpenHandler}
      />
      {simulationData && (
        <OFUSimulateSteps
          contactData={simulationData.contact}
          selectedSimulationAgentId={simulationData.agentId}
          handleCancel={handleCancel}
          isOpen={Boolean(simulationData)}
          campaign={campaign}
        />
      )}
    </>
  )
}
